import { ExternalLink } from "lucide-react";
import { cn } from "~/lib/utils";

interface YouTubeBadgeProps {
  videoId: string;
  className?: string;
}

export function YouTubeBadge({ videoId, className }: YouTubeBadgeProps) {
  return (
    <a
      href={`https://www.youtube.com/watch?v=${videoId}`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-1 rounded-md bg-muted px-2 py-1 text-xs font-medium text-muted-foreground hover:bg-muted/30",
        className,
      )}
    >
      YouTube
      <ExternalLink size={12} />
    </a>
  );
}
